import { LeadForm } from "./LeadForm";
import { Watermark } from "../brand/Logo";

const VENDA_FIELDS = [
  { name: "nome", label: "Nome", required: true, placeholder: "Seu nome completo" },
  { name: "whatsapp", label: "WhatsApp", required: true, placeholder: "(11) 90000-0000", type: "tel", inputMode: "tel" },
  { name: "administradora", label: "Administradora", required: true, placeholder: "Ex.: Itaú, Porto, Caixa" },
  { name: "valor_credito", label: "Valor do crédito", required: true, placeholder: "Ex.: R$ 300.000" },
];

const PARCEIRO_FIELDS = [
  { name: "nome", label: "Nome", required: true, placeholder: "Seu nome completo" },
  { name: "whatsapp", label: "WhatsApp", required: true, placeholder: "(11) 90000-0000", type: "tel", inputMode: "tel" },
  { name: "cidade", label: "Cidade / UF", placeholder: "Ex.: São Paulo / SP", wide: true },
  { name: "mensagem", label: "Conte um pouco sobre você", placeholder: "Opcional", textarea: true, wide: true },
];

export const VendaSection = () => (
  <section id="vender" className="scroll-mt-20 py-24 sm:py-32" data-testid="venda-section">
    <div className="mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[1fr_1.2fr] lg:gap-20">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#218FFF]">Vender minha carta</p>
        <h2 className="mt-3 text-3xl font-extrabold uppercase tracking-tight text-[#15579A] sm:text-4xl">Venda sua carta contemplada</h2>
        <p className="mt-4 text-base font-medium text-[#196ABC] md:text-lg">Tem uma carta contemplada e quer vender? Envie os dados e fazemos uma avaliação.</p>
        <p className="mt-6 text-sm leading-relaxed text-[#15579A]/75">Leva menos de um minuto. Retornamos pelo WhatsApp informado.</p>
      </div>
      <LeadForm origem="venda" fields={VENDA_FIELDS} submitLabel="Enviar para avaliação" prefix="form-venda" />
    </div>
  </section>
);

export const ParceiroSection = () => (
  <section className="relative overflow-hidden bg-[#196ABC] py-24 sm:py-32" data-testid="parceiro-section">
    <Watermark className="-left-48 -top-40" />
    <div className="relative mx-auto grid max-w-7xl gap-12 px-5 sm:px-8 lg:grid-cols-[1fr_1.2fr] lg:gap-20">
      <div>
        <p className="text-xs font-semibold uppercase tracking-[0.25em] text-[#F7F5F0]/70">Seja um parceiro</p>
        <h2 className="mt-3 text-3xl font-extrabold uppercase tracking-tight text-[#F7F5F0] sm:text-4xl">Seja um parceiro ou representante</h2>
        <p className="mt-4 text-base font-medium text-[#F7F5F0]/85 md:text-lg">Quer trabalhar com cartas contempladas ao nosso lado? Deixe seu contato.</p>
      </div>
      <LeadForm origem="parceiro" fields={PARCEIRO_FIELDS} submitLabel="Quero ser parceiro" prefix="form-parceiro" />
    </div>
  </section>
);
